module.exports = __webpack_public_path__ + "images/gadget/slider_handles.png";